import { SectionHeader } from "@/components/ui/SectionHeader";
import { CONTAINER_CLASS } from "@/components/ui/Container";
import { PersonaCard } from "@/components/ui/PersonaCard";
import { landingContent } from "@/content/landing";

interface PersonasV2Props {
  className?: string;
}

export function PersonasV2({ className = "" }: PersonasV2Props) {
  const personas = landingContent.personas.items;

  return (
    <section id="personas" className={`relative flex flex-col items-center gap-[40px] py-[80px] overflow-hidden ${className}`}>
      {/* Soft airy brand glow centred horizontally and vertically: a single radial ellipse fading to
          fully transparent toward the left/right edges (white at the section margins) and toward the
          top/bottom edges, so it reads as a soft centred wash rather than a full-width plate. Almost no
          tint sits directly behind the heading. No hard seam, no flat fill. Same on every breakpoint. */}
      <div
        className="absolute inset-0 pointer-events-none max-tablet:hidden"
        style={{
          background:
            "radial-gradient(ellipse 62% 56% at 50% 50%, var(--brand-primary-soft) 0%, rgba(255,255,255,0) 72%)",
        }}
      />
      {/* mobile (<769): stacked layout stretches the section tall — tile a centred blob every
          fixed px so coverage stays even at any height; edge-masked so no seam / no header tint. */}
      <div
        className="absolute inset-0 pointer-events-none hidden max-tablet:block"
        style={{
          background:
            "color-mix(in srgb, var(--brand-primary-soft) 50%, transparent)",
          WebkitMaskImage:
            "linear-gradient(to bottom, transparent 0px, #000 170px, #000 calc(100% - 120px), transparent 100%)",
          maskImage:
            "linear-gradient(to bottom, transparent 0px, #000 170px, #000 calc(100% - 120px), transparent 100%)",
        }}
      />

      <SectionHeader className="relative z-[1]"
        title={landingContent.personas.title}
        subtitle={landingContent.personas.subtitle}
      />

      {/* Card grid — desktop 3-col, tablet 2-col, mobile 1-col */}
      <div className={`relative grid grid-cols-3 gap-[16px] ${CONTAINER_CLASS} max-desktop:grid-cols-2 max-tablet:grid-cols-1`}>
        {personas.map((p) => (
          <PersonaCard key={p.title} image={p.image} title={p.title} description={p.description} />
        ))}
      </div>
    </section>
  );
}
